var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("h1", { class: _vm.$style.pageTitle }, [_vm._v(" Company Profile ")]),
      _vm._l(_vm.modules, function (module) {
        return _c("navigation-item", {
          key: module.id,
          attrs: { module: module, "active-module": _vm.activeModule },
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }